import { Tooltip } from '@mui/material'
import React from 'react'

const PurpleToolTip = ({
  title,
  placement = 'top',
  children,
  color = 'inherit',
}) => {
  return (
    <Tooltip
      title={title}
      placement={placement}
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: `#3E2A7C`,
            color: color, // Ensure text color is readable
            boxShadow: `none`, // Remove any box shadow
            borderRadius: `12px`,
          },
        },
        arrow: {
          sx: {
            color: `#3E2A7C`, // Ensure the arrow is also transparent
          },
        },
      }}
    >
      {children}
    </Tooltip>
  )
}

export default PurpleToolTip
